export default __webpack_public_path__ + "6923dd2b91b55151962218e1621c279e.svg";